import React, { useRef } from 'react';
import { Tooltip } from '@material-ui/core';
import PropTypes from 'prop-types';

import { ButtonText } from 'src/components/ButtonText';

import { useStyles } from './useStyles';

export const ResourceThumbnailTooltip = ({
  classes,
  thumbnailUrl,
  onClick,
  label,
  placement,
  children,
}) => {
  const styles = useStyles({ classes });

  const fullImageRef = useRef(null);

  return (
    <Tooltip
      classes={{ tooltip: styles.tooltip }}
      placement={placement}
      interactive={true}
      title={
        thumbnailUrl ? (
          <div
            className={styles.fullImageHover}
            style={{ minHeight: fullImageRef.current?.clientHeight }}
          >
            <img
              src={thumbnailUrl}
              ref={fullImageRef}
              style={{ height: fullImageRef.current?.offsetHeight }}
              alt={''}
            />
            <ButtonText
              className={styles.imageLabel}
              onClick={onClick}
            >
              {label}
            </ButtonText>
          </div>
        ) : (
          ''
        )
      }
    >
      {children}
    </Tooltip>
  );
};

ResourceThumbnailTooltip.displayName = 'ResourceThumbnailTooltip';
ResourceThumbnailTooltip.propTypes = {
  classes: PropTypes.shape(),
  thumbnailUrl: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string,
  placement: PropTypes.string,
  children: PropTypes.node.isRequired,
};
ResourceThumbnailTooltip.defaultProps = {
  classes: null,
  thumbnailUrl: null,
  label: null,
  placement: null,
};
